<template>
  <div @click="selectDayEvent(index)">
  <slot />
  <b-progress
    style="margin-top: 5px;"
    :rounded="true"
    :value="stats"
    type="is-success"
    size="is-small"
  ></b-progress>
  </div>
</template>

<script>
// import _ from 'lodash';
import habitHelper from '../../../helpers/habitHelper';

export default {
  props: {
    index: Number,
    allActiveHabitsCount: Number,
    day: String,
    activityLogs: Array,
    selectDayEvent: Function,
    habitsWithLogs: Array,
  },
  data() {
    return {
      stats: 0,
    };
  },
  mounted() {
    this.progress();
  },
  methods: {
    progress() {
      const stats = habitHelper.getHabitStatsForDay(this.day, this.habitsWithLogs);
      if (!stats.habitsDone || !stats.allActiveHabitsCount) {
        this.stats = 0;
      } else {
        this.stats = (stats.habitsDone / stats.allActiveHabitsCount) * 100;
      }
      return this.stats;
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'habitsDashboard/ADD_HABIT_LOG' || mutation.type === 'habitsDashboard/REMOVE_HABIT_LOG') {
        if (this.$isSame(mutation?.payload?.date, this.day)) this.progress();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style>
</style>
